export default __webpack_public_path__ + "static/media/harnessing-technology-for-esg.ceabf27d.jpg";